import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {translate} from '@jsverse/transloco';

@Component({
    selector: 'app-version-details-popup',
    templateUrl: './version-details-popup.component.html',
    styleUrls: ['./version-details-popup.component.scss'],
    standalone: false
})
export class VersionDetailsPopupComponent {
  version: any;
  instance: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public matdialogRef: MatDialogRef<VersionDetailsPopupComponent>) {
  }

  ngOnInit(): void {
   this.version = this.data.blueprintVersion;
   this.instance = this.data.instance;
  }

}
